import { adminHttpClient } from '../../../../commons/adminHttpClient'

const deleteIchraProductClass = (productClassId: string): Promise<string> => {
  return adminHttpClient.delete('AdminDashboard/ichra/ProductClass/remove', { data: { id: productClassId } })
}

export default deleteIchraProductClass
